import React  from 'react'
import { Link } from 'react-router-dom'
import "./whatsapp.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWhatsapp} from '@fortawesome/free-brands-svg-icons'
const Whatsapp = () => {
  return (
    <Link to="https://wa.me/9779863841456" className="whatsapp-me">  <FontAwesomeIcon icon={faWhatsapp} className="wesizv" /></Link>
  )
}

export default Whatsapp